module.exports = __webpack_public_path__ + "img/seta_baixo.fa4aa073.png";